import React, { useState } from 'react';
import { Form, Modal, Button, Select, notification } from 'antd';
import { handleFormChange, layoutEdit, validateMessages } from '../../../shared/Utils';
import { allRequestBookingStatusTypes, RequestBooking } from '../../../shared/types';
import { useCurrentRequestBooking } from '../hooks/useCurrentRequestBooking';
import { useUpdateStatusRequestBooking } from '../../../GraphQL/hooks/useUpdateStatusRequestBooking';

const RequestBookingEditModal = ({ isOpen, onRequestClose, updateList }) => {
    const [form] = Form.useForm();
    const [formError, setFormError] = useState(false);
    const [newRequestBooking, setRequestBooking] = useState<RequestBooking>();
    const { currentRequestBooking } = useCurrentRequestBooking();

    const handleRequestBookingStatusChange = (value: string) => {
        setRequestBooking({ ...newRequestBooking, status: value });
    };

    const { mutation, loading: creating } = useUpdateStatusRequestBooking();

    const handleCommit = async () => {
        try {
            const values = await form.validateFields();
            if (values) {
                mutation({
                    _id: currentRequestBooking._id,
                    ...values,
                })
                    .then(() => {
                        onRequestClose(false);
                        updateList();
                    })
                    .finally(() => {
                        notification.success({
                            message: 'Request Booking status updated successfully',
                            description: 'The request booking status has been updated successfully.',
                        });
                    })
                    .catch((err) => {
                        notification.error({
                            message: 'Failed to update request booking status',
                            description: 'An error occurred while updating the request booking status.',
                        });

                        console.error('Failed to update request booking status:', err);
                    });
            }
        } catch (errorInfo) {
            console.log('Failed: Form is empty');
        }
    };

    const handleCancel = () => {
        onRequestClose(false);
    };

    return (
        <Modal
            title="Edit Request Booking Status"
            open={isOpen}
            destroyOnClose={true}
            onCancel={handleCancel}
            footer={[
                <Button key="cancel" onClick={handleCancel}>
                    Cancel
                </Button>,
                <Button key="edit" type="primary" onClick={handleCommit} disabled={formError}>
                    Edit
                </Button>,
            ]}
        >
            <Form<RequestBooking>
                {...layoutEdit}
                form={form}
                name="nest-messages"
                onFieldsChange={() => {
                    setFormError(handleFormChange(form));
                }}
                onValuesChange={(changedValues, allValues) => setRequestBooking(allValues)}
                validateMessages={validateMessages}
            >
                <Form.Item
                    name="status"
                    label="Status"
                    rules={[{ required: true }]}
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    style={{ display: 'inline-block', width: '80%' }}
                >
                    <Select
                        placeholder="Select request booking status"
                        value={currentRequestBooking?.status}
                        onChange={handleRequestBookingStatusChange}
                    >
                        {(allRequestBookingStatusTypes ?? []).map((type) => (
                            <Select.Option key={type} value={type}>
                                {type}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default RequestBookingEditModal;
